import { sample } from 'effector';
import { spread } from 'patronum';
import {
  $centerHomeFilters,
  $chHexagons,
  $chPoints,
  $chStartPoints,
  $hexProp,
  $mobilePopup,
  $priceType,
} from './stores.js';
import {
  applyFiltersEv,
  changeCenterHomeFiltersEv,
  changeHexPropEv,
  changeMobilePopupEv,
  initCHStoreEv,
  resetCenterHomeFiltersEv,
  resetMobilePopupEv,
  togglePriceTypeEv,
} from './events.js';
import { filterPoints } from './utils.js';
import ch_hexagons from '../../data/ch_hexagons.json';
import ch_points from '../../data/ch_points.json';
import { formatNumberCompact } from '../../utils/format-utils.js';
import { calculateThresholdsEv } from '../gradientModel/index.js';

$centerHomeFilters.reset(resetCenterHomeFiltersEv);

$hexProp.on(changeHexPropEv, (state, payload) => payload);

$priceType.on(togglePriceTypeEv, (state, payload) => {
  if (payload) return 'absolute';
  return 'meter';
});

$mobilePopup
  .on(changeMobilePopupEv, (state, payload) => payload)
  .reset(resetMobilePopupEv);

sample({
  source: $centerHomeFilters,
  clock: changeCenterHomeFiltersEv,
  fn: (source, clock) => {
    if (clock.field === 'rooms' || clock.field === 'house_type') {
      if (source[clock.field].includes(clock.value)) {
        return {
          ...source,
          [clock.field]: source[clock.field].filter(
            (item) => item !== clock.value
          ),
        };
      }
      return {
        ...source,
        [clock.field]: [...source[clock.field], clock.value],
      };
    }
    return {
      ...source,
      [clock.field]: clock.value,
    };
  },
  target: $centerHomeFilters,
});

sample({
  source: [$chStartPoints, $centerHomeFilters],
  clock: applyFiltersEv,
  fn: ([points, filters]) => {
    return filterPoints(points, filters);
  },
  target: $chPoints,
});

sample({
  clock: initCHStoreEv,
  fn: () => {
    return {
      hexagons: ch_hexagons.features.map((item) => {
        return {
          ...item,
          properties: {
            ...item.properties,
            index_main: item.properties.room1_hex_mean,
          },
        };
      }),
      points: ch_points.features.map((item) => {
        return {
          ...item,
          properties: {
            ...item.properties,
            label: `${item.properties.rooms}-ком., ${formatNumberCompact(
              item.properties.price
            )} тг ${formatNumberCompact(
              item.properties.price_per_meter
            )} тг / кв. м`,
          },
        };
      }),
    };
  },
  target: spread({
    targets: {
      hexagons: [$chHexagons, calculateThresholdsEv],
      points: [$chStartPoints, $chPoints],
    },
  }),
});

sample({
  source: [$chHexagons, $priceType],
  clock: $hexProp.updates,
  fn: ([hexagons, priceType], clock) => {
    return hexagons.map((item) => {
      return {
        ...item,
        properties: {
          ...item.properties,
          index_main:
            item.properties[
              `${clock}${priceType === 'absolute' ? '_full' : ''}`
            ],
        },
      };
    });
  },
  target: [$chHexagons, calculateThresholdsEv],
});

sample({
  source: [$chHexagons, $hexProp],
  clock: $priceType.updates,
  fn: ([hexagons, hexProp], priceType) => {
    return hexagons.map((item) => {
      return {
        ...item,
        properties: {
          ...item.properties,
          index_main:
            item.properties[
              `${hexProp}${priceType === 'absolute' ? '_full' : ''}`
            ],
        },
      };
    });
  },
  target: [$chHexagons, calculateThresholdsEv],
});

sample({
  source: $chStartPoints,
  clock: resetCenterHomeFiltersEv,
  fn: (source) => source,
  target: $chPoints,
});
